import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, CURRENCY_RATE, M_POST } from '@/utils/api';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

@Module({ name: 'currency' })
export default class Currency extends VuexModule {
  @Action({ rawError: true })
  async fetchCurrencyRate(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CURRENCY_RATE,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch currency rate failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch currency rate failed');
    }
  }
}
